var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPageBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_51257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24.5305 0.984863)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_51257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 12.9849L14.9305 16.0599L13.5305 17.4849L9.03052 12.9849L13.5305 8.48486L14.9305 9.90986L11.8555 12.9849ZM12.5305 22.9849C13.9139 22.9849 15.2139 22.7224 16.4305 22.1974C17.6472 21.6724 18.7055 20.9599 19.6055 20.0599C20.5055 19.1599 21.218 18.1015 21.743 16.8849C22.268 15.6682 22.5305 14.3682 22.5305 12.9849C22.5305 11.6015 22.268 10.3015 21.743 9.08486C21.218 7.8682 20.5055 6.80986 19.6055 5.90986C18.7055 5.00986 17.6472 4.29736 16.4305 3.77236C15.2139 3.24736 13.9139 2.98486 12.5305 2.98486C11.1472 2.98486 9.84718 3.24736 8.63052 3.77236C7.41385 4.29736 6.35552 5.00986 5.45552 5.90986C4.55552 6.80986 3.84302 7.8682 3.31802 9.08486C2.79302 10.3015 2.53052 11.6015 2.53052 12.9849C2.53052 14.3682 2.79302 15.6682 3.31802 16.8849C3.84302 18.1015 4.55552 19.1599 5.45552 20.0599C6.35552 20.9599 7.41385 21.6724 8.63052 22.1974C9.84718 22.7224 11.1472 22.9849 12.5305 22.9849ZM12.5305 20.9849C10.2972 20.9849 8.40552 20.2099 6.85552 18.6599C5.30552 17.1099 4.53052 15.2182 4.53052 12.9849C4.53052 10.7515 5.30552 8.85986 6.85552 7.30986C8.40552 5.75986 10.2972 4.98486 12.5305 4.98486C14.7639 4.98486 16.6555 5.75986 18.2055 7.30986C19.7555 8.85986 20.5305 10.7515 20.5305 12.9849C20.5305 15.2182 19.7555 17.1099 18.2055 18.6599C16.6555 20.2099 14.7639 20.9849 12.5305 20.9849Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageBtn);
export default __webpack_public_path__ + "static/media/previousPageBtn.bf4df70edf2238d3c1873aa0904128c0.svg";
export { ForwardRef as ReactComponent };